module.exports = __webpack_public_path__ + "img/service-bg4.622c1ee6.png";